// Whether the Timeline screen shows for the current account: the global flag
// AND the account's timeline toggle (session.account.features.timeline). The
// server applies the same rule to GET /timeline/get?source=map.

import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { useFeatureFlag } from './useFeatureFlag';
import { TIMELINE_FLAG } from '../utilities/timelineNav';

export function useTimelineEnabled(): boolean {
  const flagOn = useFeatureFlag(TIMELINE_FLAG, false);
  const accountOn = useSelector((s: RootState) => (s.session as any)?.account?.features?.timeline === true);
  return flagOn && accountOn;
}
